import { GetTranslationsWithDateResponse, TranslationKeyLanguages } from '../../../model';

export class SetSelectedTranslations {
  static readonly type = '[Translation Table] Set Selected Translations';
  constructor(public payload: Array<TranslationKeyLanguages>) {}
}

export class ResetTranslationSelection {
  static readonly type = '[Translation Table] Reset Translation Selection';
}

export class UpdateSelectedTranslation {
  static readonly type = '[Translation Table] Update Selected Translation';
  constructor(public payload: TranslationKeyLanguages) {}
}

export class SetLastModifiedDateToNow {
  static readonly type = '[Translation Table] Set Last Modified Date To Now';
}

export class GetTranslations {
  public static type = '[Translation Table] Get Translations';
  constructor(public payload: Array<string> = []) {}
}

export class SetTranslations {
  public static type = '[Translation Table] Set Translations';
  constructor(public payload: GetTranslationsWithDateResponse) {}
}

export class SetDisplayedTranslationsCount {
  public static type = '[Translation Table] Set Displayed Translations Count';
  constructor(public payload: number) {}
}
